import React from 'react';
import styled from 'styled-components';
import { COLORS, device } from '../../constants';
import { MotionProjectTag } from '../Motion';

interface TagProps extends React.HTMLProps<HTMLDivElement> {
  $tagBorder?: React.CSSProperties['border'];
  isAnimated?: boolean;
}

export const Tag: React.FC<TagProps> = ({
  children,
  $tagBorder = `1px solid ${COLORS.TAG_BORDER}`,
  isAnimated = false,
  ...props
}) => {
  return (
    <TagStyle $tagBorder={$tagBorder} isAnimated={isAnimated} {...props}>
      {children}
    </TagStyle>
  );
};

const TagStyle = styled(MotionProjectTag)<{ $tagBorder: React.CSSProperties['border'] }>`
  padding: 4px 12px;
  border: ${props => props.$tagBorder};
  @media screen and ${device.md} {
    padding: 2px 5px;
    > h4 {
      font-size: 13px;
    }
  }
  @media screen and ${device.sm} {
    padding: 0 3px;
    > h4 {
      font-size: 10px;
    }
  }
`;
